import News1 from 'images/news/list/news1.jpg'
import News10 from 'images/news/list/news10.png'
import News11 from 'images/news/list/news11.png'
import News12 from 'images/news/list/news12.png'
import News13 from 'images/news/list/news13.png'
import News2 from 'images/news/list/news2.jpg'
import News3 from 'images/news/list/news3.jpg'
import News4 from 'images/news/list/news4.jpg'
import News5 from 'images/news/list/news5.jpg'
import News6 from 'images/news/list/news6.png'
import News7 from 'images/news/list/news7.png'
import News8 from 'images/news/list/news8.png'
import News9 from 'images/news/list/news9.png'
import { chunkArray } from '../../../utils'
import {
  AviaAnimalRescueJiabaoNews,
  AviaPetAdoptionTangtangNews,
  SolitaireClashMomsWeekWithLoveNews,
  SolitaireHorizontalNews,
  SolitaireMovesCardsNews,
  SolitaireTermsExplainedNews,
  SolitaireUndoTrickNews,
  ThisSimpleSolitaireGaveMeMoreNews,
} from '../blogs'
import { NewsCategory, NewsItem } from './page'

export const NewsItem0: NewsItem = {
  id: 0,
  image: News1,
  breadcrumb: [NewsCategory.GameEvents, 'May 07, 2025'],
  title: 'Avia Launches First "Mom’s Week" to Celebrate Moms in Solitaire Clash',
  url: 'https://www.prnewswire.com/news-releases/avia-launches-first-ever-moms-week-in-solitaire-clash-to-honor-moms-during-a-week-of-joy-connection-and-community-302448415.html',
}
export const NewsItem1: NewsItem = {
  id: 1,
  image: News2,
  breadcrumb: [NewsCategory.IndustryNews, 'Apr 16, 2025'],
  title: 'Avia Wins Silver 2025 TITAN Business Award for Excellence in Customer Service',
  url: 'https://www.prnewswire.com/news-releases/avia-wins-silver-2025-titan-business-award-for-excellence-in-customer-service-302430014.html?tc=eml_cleartime',
}
export const NewsItem2: NewsItem = {
  id: 2,
  image: News3,
  breadcrumb: [NewsCategory.CompanyCulture, 'Apr 16, 2025'],
  title: 'Bringing Joy Back to the Workplace: How Companies Are Beating Back Burnout Culture',
  url: 'https://www.worklife.news/culture/bringing-joy-back-to-the-workplace-how-companies-are-beating-back-burnout-culture/',
}
export const NewsItem3: NewsItem = {
  id: 3,
  image: News4,
  breadcrumb: [NewsCategory.IndustryNews, 'Mar 12, 2025'],
  title: 'Vickie Chen, CEO of Avia – Interview Series',
  url: 'https://www.gaming.net/vickie-chen-ceo-of-avia-interview-series/',
}
export const NewsItem4: NewsItem = {
  id: 4,
  image: News5,
  breadcrumb: [NewsCategory.IndustryNews, 'Mar 06, 2025'],
  title: 'The High Cost of Disengagement with Vickie Chen ',
  url: 'https://www.benefitspro.com/2025/03/06/the-high-cost-of-disengagement-a-qa-with-vickie-chen/',
}
export const NewsItem5: NewsItem = {
  id: 5,
  image: News6,
  breadcrumb: [NewsCategory.IndustryNews, 'Feb 21, 2025'],
  title: 'How Avia Is Building a Seamless Customer Service Experience For Casual Mobile Gamers',
  url: 'https://www.sarasotamagazine.com/advantagepoint/2025/02/how-avia-is-building-a-seamless-customer-service-experience-for-casual-mobile-gamers',
}
export const NewsItem6: NewsItem = {
  id: 6,
  image: News7,
  breadcrumb: [NewsCategory.IndustryNews, 'Feb 11, 2025'],
  title:
    'How Entrepreneur Vickie Chen and Her Company Avia Are Redefining Employee Engagement by Enabling Employees to Pitch Their Own Promotions',
  url: 'https://www.ceotodaymagazine.com/2025/02/how-entrepreneur-vickie-chen-and-her-company-avia-are-redefining-employee-engagement-by-enabling-employees-to-pitch-their-own-promotions/',
}
export const NewsItem7: NewsItem = {
  id: 7,
  image: News8,
  breadcrumb: [NewsCategory.IndustryNews, 'Jan 28, 2025'],
  title: 'AviaGames: A Pioneer in Skills Based Mobile Gaming',
  url: 'https://muddyrivernews.com/business/paid-promotional/aviagames-a-pioneer-in-skills-based-mobile-gaming/20250128101741/',
}
export const NewsItem8: NewsItem = {
  id: 8,
  image: News9,
  breadcrumb: [NewsCategory.CompanyCulture, 'Jan 22, 2025'],
  title: 'Why managers should let employees ‘pitch’ themselves for promotions',
  url: 'https://www.fastcompany.com/91263770/why-managers-should-let-employees-pitch-themselves-for-promotions',
}
export const NewsItem9: NewsItem = {
  id: 9,
  image: News10,
  breadcrumb: [NewsCategory.GameUpdates, 'Dec 27, 2024'],
  title: 'Top 5 mobile games from Avia: Must-Play hits for every gamer',
  url: 'https://euroweeklynews.com/2024/12/27/top-5-mobile-games-from-avia-must-play-hits-for-every-gamer/',
}
export const NewsItem10: NewsItem = {
  id: 10,
  image: News11,
  breadcrumb: [NewsCategory.IndustryNews, 'Dec 29,2024'],
  title: 'Avia Celebrates 8 Years of Innovation and Growth in Mobile Gamin',
  url: 'https://techbullion.com/aviagames-marks-8-year-milestone-of-mobile-gaming-innovation-expanding-player-communities/',
}
export const NewsItem11: NewsItem = {
  id: 11,
  image: News12,
  breadcrumb: [NewsCategory.IndustryNews, 'Nov 04, 2024'],
  title: 'Avia Wins Big at the 2024 NYX Game Awards with Three Prestigious Titles',
  url: 'https://www.prnewswire.com/news-releases/avia-celebrates-triple-victory-in-2024-nyx-game-awards-season-2-302295659.html',
}
export const NewsItem12: NewsItem = {
  id: 12,
  image: News13,
  breadcrumb: [NewsCategory.IndustryNews, 'Dec 31,2024'],
  title: 'Avia Wins 2024 Globee Award for Consumer Product or Service of the Year',
  url: 'https://globeeawards.com/achievement/winners/2/',
}

export const NewsInfoList = [
  AviaAnimalRescueJiabaoNews,
  AviaPetAdoptionTangtangNews,
  SolitaireClashMomsWeekWithLoveNews,
  ThisSimpleSolitaireGaveMeMoreNews,
  SolitaireHorizontalNews,
  NewsItem0,
  SolitaireMovesCardsNews,
  SolitaireUndoTrickNews,
  NewsItem1,
  SolitaireTermsExplainedNews,
  NewsItem2,
  NewsItem3,
  NewsItem4,
  NewsItem5,
  NewsItem6,
  NewsItem7,
  NewsItem8,
  NewsItem9,
  NewsItem10,
  NewsItem11,
  NewsItem12,
]

export const NewsGroups = chunkArray(NewsInfoList, 6)
export const MobileNewsGroups = chunkArray(NewsInfoList, 4)
export const NewsGroupsPage = Array.from({ length: NewsGroups.length }, (_, i) => i + 1)
export const MobileNewsGroupsPage = Array.from({ length: MobileNewsGroups.length }, (_, i) => i + 1)
